/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_First_BodyInputs */

const en_start_page_first_body = /** @type {(inputs: Start_Page_First_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The booking lands in your schedule, your client gets a confirmation and a reminder, and you see the whole day on your phone.`)
};

const pl_start_page_first_body = /** @type {(inputs: Start_Page_First_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja trafia do grafiku, podopieczny dostaje potwierdzenie i przypomnienie, a Ty widzisz cały dzień w telefonie.`)
};

/**
* | output |
* | --- |
* | "The booking lands in your schedule, your client gets a confirmation and a reminder, and you see the whole day on your phone." |
*
* @param {Start_Page_First_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_first_body = /** @type {((inputs?: Start_Page_First_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_First_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_first_body(inputs)
	return en_start_page_first_body(inputs)
});